import React, { createContext, useState, useEffect } from 'react';
import Client from 'shopify-buy';
import {get} from 'lodash'
const client = Client.buildClient({
  domain: process.env.SHOPIFY_STORE_URL, // "leveluptutorialsstore.myshopify.com",
  storefrontAccessToken: process.env.SHOPIFY_ACCESS_TOKEN, // "e41e19f98903b8f577225487c40133ce",
});

const defaultValues = {
  isCartOpen: false,
  toggleCartOpen: () => {},
  cart: [],
  addProductToCart: () => {},
  updateProductQuantity: () => {},
  removeProductFromCart: () => {},
  checkCoupon: () => {},
  client,
  checkout: {
    lineItems: [],
  },
};

export const StoreContext = createContext(defaultValues);

// Check if it's a browser
const isBrowser = typeof window !== "undefined"

export const StoreProvider = ({ children }) => {
  const [checkout, setCheckout] = useState(defaultValues.checkout);
  const [isCartOpen, setCartOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const checkoutID = localStorage.getItem("checkout_id");

  const toggleCartOpen = () => setCartOpen(!isCartOpen);

  useEffect(() => {
    // localStorage.removeItem("checkout_id");
    // console.log(`checkoutID: ${checkoutID}`);
    initializeCheckout();
  }, []);

  const getNewId = async () => {
    // console.group('getNewId');

    try {
      const newCheckout = await client.checkout.create();
      // console.log(`isBrowser: ${isBrowser}`);
      if (isBrowser) {
        localStorage.setItem("checkout_id", newCheckout.id);
      }
      // console.group('newCheckout');
      // console.log(newCheckout);
      // console.groupEnd();
      return newCheckout;
    } catch (e) {
      console.error(e);
    }
    // console.groupEnd();

  };

  const initializeCheckout = async () => {
    // console.group("initializeCheckout");

    try {
      setLoading(true);
      // Check if id exists
      const currentCheckoutId = isBrowser
        ? localStorage.getItem("checkout_id")
        : null;
      // console.log(`currentCheckoutId: ${currentCheckoutId}`);
      let newCheckout = null;

      if (currentCheckoutId) {
        // If id exists, fetch checkout from Shopify
        newCheckout = await client.checkout.fetch(currentCheckoutId);
        // console.log(newCheckout);
        if ((get(newCheckout, "completedAt"), null)) {
          newCheckout = await getNewId();
        }
      } else {
        // If id does not, create new checkout
        newCheckout = await getNewId();
      }

      // Set checkout to state
      setCheckout(newCheckout);
      // setTimeout(function () {
      //   console.group("newCheckout");
      //   console.log(newCheckout);
      //   console.groupEnd();
      // }, 300);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
    // console.groupEnd();
  };

  const addProductToCart = async (variantId) => {
    // console.group("addProductToCart");
    // console.log(`checkout:`, checkout);
    try {
      setLoading(true);
      const lineItems = [
        {
          variantId,
          quantity: 1,
        },
      ];
      const newCheckout = await client.checkout.addLineItems(
        checkout.id,
        lineItems
      );
      // Buy Now Button Code
      // window.open(addItems.webUrl, "_blank")
      setCheckout(newCheckout);
      // console.log(addItems.webUrl)
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
    // console.groupEnd();
  };

  const updateProductQuantity = async (lineItemId, quantity) => {
    // console.group("updateProductQuantity");
    // console.log(`lineItemId: ${lineItemId}`);
    // console.log(`quantity: ${quantity}`);
    try {
      setLoading(true);
      const newCheckout = await client.checkout.updateLineItems(
        checkout.id,
        [
          {
            id: lineItemId,
            quantity,
          },
        ]
      );
      setCheckout(newCheckout);
      setLoading(false);

    } catch (e) {
      setLoading(false);
      console.error(e);
    }
    // console.groupEnd();
  };

  const removeProductFromCart = async (lineItemId) => {
    try {
      setLoading(true);
      const newCheckout = await client.checkout.removeLineItems(checkout.id, [
        lineItemId,
      ]);
      setCheckout(newCheckout);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const checkCoupon = async (coupon) => {
    setLoading(true);
    const newCheckout = await client.checkout.addDiscount(
      checkout.id,
      coupon
    );
    setCheckout(newCheckout);
    setLoading(false);
  };

  const removeCoupon = async (coupon) => {
    setLoading(true);
    const newCheckout = await client.checkout.removeDiscount(
      checkout.id,
      coupon
    );
    setCheckout(newCheckout);
    setLoading(false);
  };

  return (
    <StoreContext.Provider
      value={{
        ...defaultValues,
        checkout,
        addProductToCart,
        toggleCartOpen,
        isCartOpen,
        isLoading,
        updateProductQuantity,
        removeProductFromCart,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
